function AmazonPayoutHistoryService(ApiService) {
  'ngInject';
  const service = {};

  service.listPayoutHistory = function (orgId, pageNumber, size, sortBy, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/amazon_payout_reports.json?page=${pageNumber}&size=${size}&sort=${sortBy}`, callbackFunc);
  };

  service.retryJob = function (orgId, recordId, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/amazon_payout_reports/${recordId}/retry.json`, {id : recordId}, callbackFunc);
  };

  service.goBackHistroy = function (orgId, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/amazon_payout_reports/payout_history.json`, {}, callbackFunc);
  };

  return service;
}

export default {
  name: 'AmazonPayoutHistoryService',
  fn: AmazonPayoutHistoryService
};

